import { IIconProps } from "./types"

export default function IconVec1(props: IIconProps) {
  const width = props.size || props.width || 37
  const height = props.size || props.height || 18
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 37 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.8845 7.86235L4.77116 2.41134L20.8297 0L24.321 7.71563L5.8845 7.86235Z"
        fill="#CCCCCC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M37 14.6218H28.8788V18L21.8854 13.4895L28.8788 8.96389V12.3572H37V14.6218Z"
        fill="#3A3939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.95249 9.44974L18.9986 9.59647L18.1699 16.0896L0.659344 13.8851L0 6.52305L2.79956 6.27473L3.95249 9.44974Z"
        fill="#3A3939"
      />
    </svg>
  )
}
